export class Clock {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "CLOCK";
    this.scene = "Clock";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
  }
  async animate({ options }) {
    this.onAir = true;
    this.data = [];

    this.data.push({
      name: "Group",
      value: { text: options.mode },
    });

    this.data.push({
      name: "Period",
      value: { text: options.period },
    });

    this.data.push({
      name: "Home Score",
      value: { text: options.homeScore?.toString() },
    });
    this.data.push({
      name: "Away Score",
      value: { text: options.awayScore?.toString() },
    });

    this.data.push({
      name: "Home Score",
      value: {
        text: options?.homeScore ?? "",
      },
    });

    this.data.push({
      name: "Away Score",
      value: {
        text: options?.awayScore ?? "",
      },
    });

    this.data.push({
      name: "Home Team Code",
      value: {
        text: options?.game?.home_team?.code ?? "",
      },
    });
    this.data.push({
      name: "Home Team Name",
      value: {
        text: options?.game?.home_team?.name?.toUpperCase() ?? "",
      },
    });
    this.data.push({
      name: "Home Team Short Name",
      value: {
        text: options?.game?.home_team?.short_name?.toUpperCase() ?? "",
      },
    });
    this.data.push({
      name: "Home Team Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.home_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.third_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Code",
      value: {
        text: options?.game?.away_team?.code ?? "",
      },
    });
    this.data.push({
      name: "Away Team Name",
      value: {
        text: options?.game?.away_team?.name?.toUpperCase() ?? "",
      },
    });
    this.data.push({
      name: "Away Team Short Name",
      value: {
        text: options?.game?.away_team?.short_name?.toUpperCase() ?? "",
      },
    });
    this.data.push({
      name: "Away Team Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.away_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.third_badge || "",
      },
    });

    let home_kit = options.homeKit;

    this.data.push({
      name: "Home Team Kit BG Colour",
      value: {
        colour:
          options.game?.home_team?.variables?.[home_kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Home Team Kit Text Colour",
      value: {
        colour:
          options.game?.home_team?.variables?.[home_kit + "_kit_text"] || "",
      },
    });

    this.data.push({
      name: "Home Team Kit BG Colour String",
      value: {
        text: options.game?.home_team?.variables?.[home_kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Home Team Kit Text Colour String",
      value: {
        text:
          options.game?.home_team?.variables?.[home_kit + "_kit_text"] || "",
      },
    });
    let away_kit = options.awayKit;

    this.data.push({
      name: "Away Team Kit BG Colour",
      value: {
        colour:
          options.game?.away_team?.variables?.[away_kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit Text Colour",
      value: {
        colour:
          options.game?.away_team?.variables?.[away_kit + "_kit_text"] || "",
      },
    });

    this.data.push({
      name: "Away Team Kit BG Colour String",
      value: {
        text: options.game?.away_team?.variables?.[away_kit + "_kit_bg"] || "",
      },
    });
    this.data.push({
      name: "Away Team Kit Text Colour String",
      value: {
        text:
          options.game?.away_team?.variables?.[away_kit + "_kit_text"] || "",
      },
    });
    this.data.push({
      name: "Home Red Cards",
      value: { text: options.auto_enabled?.toString() },
    });
    this.data.push({
      name: "Away Red Cards",
      value: { text: options.SSGoalAnim?.toString() },
    });
    this.data.push({
      name: "Additional Time", 
      value: { text: options.extraTimeToggle?.toString() },
    });
    this.data.push({
      name: "Leg", 
      value: { text: options.analysisperiod?.toString() },
    });

    this.data.push({
      name: "Home Agg Score",
      value: { text: options.clockHide?.toString() },
    });


    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
  update({ options }) {
    this.data = [];

    this.data.push({
      name: "Home Agg Score",
      value: { text: options.clockHide?.toString() },
    });

    this.data.push({
      name: "Group",
      value: { text: options.mode },
    });
    this.data.push({
      name: "Additional Time", 
      value: { text: options.extraTimeToggle?.toString() },
    });

    this.data.push({
      name: "Period",
      value: { text: options.period },
    });

    this.data.push({
      name: "Home Score",
      value: { text: options.homeScore?.toString() },
    });
    this.data.push({
      name: "Away Score",
      value: { text: options.awayScore?.toString() },
    });
    this.data.push({
      name: "Home Red Cards",
      value: { text: options.auto_enabled?.toString() },
    });
    this.data.push({
      name: "Away Red Cards",
      value: { text: options.SSGoalAnim?.toString() },
    });
    this.sendUpdate(this.scene, this.data);
  }
}
